import React, { useEffect, useState } from 'react';
import { parseOwnershipPercentage } from '../../../../utils/editOwnershipPercentage';

export default function OwnershipPercentageField({ value, maximum, parentName, personName, readOnly, onCommit }) {
  const [draft, setDraft] = useState(String(value));
  const [error, setError] = useState('');
  useEffect(() => { setDraft(String(value)); setError(''); }, [value]);
  const commit = () => {
    if (draft === String(value)) return;
    const parsed = parseOwnershipPercentage(draft);
    if (parsed === null) { setDraft(String(value)); return; }
    try {
      const next = Math.min(parsed, maximum);
      onCommit(next);
      setDraft(String(next));
      setError('');
    } catch (err) { setError(err.message); }
  };
  return (
    <label className="kycCpOwnershipPercent" title={`Ownership in ${parentName}. Maximum ${maximum}%.`}>
      <span className="kycCpOwnershipPercentValue">
        <input
          aria-label={`Ownership in ${parentName} for ${personName || 'this person'}`}
          aria-invalid={Boolean(error)}
          inputMode="decimal" placeholder="....." value={draft} readOnly={readOnly}
          style={{ width: `${draft.length || 3}ch` }}
          onFocus={(event) => event.target.select()}
          onChange={(event) => {
            const text = event.target.value;
            if (!/^\d*\.?\d*$/.test(text)) return;
            setDraft(text !== '' && text !== '.' && Number(text) > maximum ? String(maximum) : text);
            setError('');
          }}
          onBlur={commit}
          onKeyDown={(event) => {
            if (event.key === 'Enter') { event.preventDefault(); event.currentTarget.blur(); }
            else if (event.key === 'Escape') { event.preventDefault(); setDraft(String(value)); setError(''); }
            else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !/^[\d.]$/.test(event.key)) event.preventDefault();
          }}
        />
        <span>%</span>
      </span>
      {error && <span className="kycCpOwnershipPercentError" role="alert">{error}</span>}
    </label>
  );
}
